module.exports = __webpack_public_path__ + "static/fashion-91f3a3821ad4790f967f686337fa42f6.png";